import firedux from '../firedux'
import watchAuth from './auth'
import {watchChatSettings} from './chat_settings'
import {watchUsers} from './users'
import {watchPresences} from './presences'
import {watchCurrentUser, unwatchCurrentUser} from './current_user'
import {watchCurrentUserPresence, unwatchCurrentUserPresence} from './current_user_presence'
import {watchConnection, unwatchConnection} from './connection'
import {watchCurrentUserIdle, unwatchCurrentUserIdle} from './current_user_idle'
import {watchCurrentUserActivity, unwatchCurrentUserActivity} from './current_user_activity'
import {watchConversations, unwatchConversations} from './conversations'
import {watchConversationStack, unwatchConversationStack} from './conversation_stack'
import {watchRecentConversations} from './recent_conversations'
import {watchNotifications, unwatchNotifications} from './notifications'
import {watchCurrentGuest, unwatchCurrentGuest} from './current_guest'
import {watchCurrentUserSessions, unwatchCurrentUserSessions} from './current_user_sessions'
import {watchCurrentExpertSessionRequests, unwatchCurrentExpertSessionRequests} from './current_expert_session_requests'
import {watchCurrentCustomer, unwatchCurrentCustomer} from './current_customer'
import {watchGlobalGroupChats, watchPrivateGroupChats} from './group_chats'
import {watchBookmarkedGroups, unwatchBookmarkedGroups} from './bookmarked_group_chats'
import {watchUserGroupChatSubscriptions, unwatchUserGroupChatSubscriptions} from './subscribed_group_chats'
import {watchGlobalGroupOrders} from './group_chat_orders'
import {watchChatListView} from './chat_list'
import watchViewportResize from './viewport_resize'
import {watchAdvertisements} from './advertisements'

export const watchUI = () => {
  watchViewportResize()
  watchChatSettings()
  watchChatListView()
  watchUsers()
  watchAdvertisements()
  watchPresences()
  watchGlobalGroupChats()
  watchGlobalGroupOrders()
  watchPrivateGroupChats()

  let currentUid

  watchAuth((authData) => {
    if (authData) {
      if (authData.provider === 'custom') {
        if (!currentUid) currentUid = authData.uid

        unwatchCurrentGuest()
        unwatchConversationStack(currentUid)
        watchCurrentUser(authData.uid)
        watchCurrentUserPresence(authData.uid)
        watchConnection(authData.uid)
        watchCurrentUserIdle(authData.uid)
        watchCurrentUserActivity()
        watchCurrentUserSessions(authData.uid, authData.auth.role)
        watchCurrentExpertSessionRequests(authData.uid, authData.auth.role)
        watchCurrentCustomer(authData.uid)
        watchConversations(authData.uid)
        watchConversationStack(authData.uid)
        watchRecentConversations(authData.uid)
        watchBookmarkedGroups(authData.uid)
        watchUserGroupChatSubscriptions(authData.uid)
        watchNotifications(authData.uid)

        currentUid = authData.uid
      }
      else if (authData.provider === 'anonymous') {
        if (!currentUid) currentUid = authData.uid

        unwatchNotifications()
        unwatchUserGroupChatSubscriptions(currentUid)
        unwatchBookmarkedGroups(currentUid)
        unwatchConversationStack(currentUid)
        unwatchConversations()
        unwatchCurrentExpertSessionRequests()
        unwatchCurrentCustomer()
        unwatchCurrentUserSessions()
        unwatchCurrentUserActivity()
        unwatchCurrentUserIdle()
        unwatchConnection()
        unwatchCurrentUserPresence()
        unwatchCurrentUser()
        watchCurrentGuest(authData.uid)
        watchConversationStack(authData.uid)

        currentUid = authData.uid
      }
    }
  })
}

export const watchEmbeds = () => {
  watchChatSettings()
  watchPrivateGroupChats()
  watchUsers()

  let currentUid

  watchAuth((authData) => {
    if (authData) {
      if (authData.provider === 'custom') {
        if (!currentUid) currentUid = authData.uid

        watchCurrentUser(authData.uid)
        watchConnection(authData.uid)
        watchCurrentUserPresence(authData.uid)
        watchCurrentUserIdle(authData.uid)
        watchCurrentUserActivity()
        watchCurrentUserSessions(authData.uid, authData.auth.role)
        watchCurrentExpertSessionRequests(authData.uid, authData.auth.role)
        watchCurrentCustomer(authData.uid)
        watchBookmarkedGroups(authData.uid)
        watchUserGroupChatSubscriptions(authData.uid)

        currentUid = authData.uid
      }
    }
    else {
      if (currentUid) {
        unwatchUserGroupChatSubscriptions(currentUid)
        unwatchBookmarkedGroups(currentUid)
      }
      unwatchCurrentCustomer()
      unwatchCurrentExpertSessionRequests()
      unwatchCurrentUserSessions()
      unwatchCurrentUserActivity()
      unwatchCurrentUserIdle()
      unwatchCurrentUserPresence()
      unwatchConnection()
      unwatchCurrentUser()
    }
  })
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/index.js
 **/